import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Loader2 } from "lucide-react";
import { AuthShell, GoogleButton } from "@/pages/authShared";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", mobile: "", marketing_consent: false });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) return setErr("Password must be at least 6 characters");
    setLoading(true); setErr("");
    try { await register(form); toast.success("Account created!"); navigate("/account"); }
    catch (e) { setErr(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Create account" subtitle="Save your library, orders and downloads.">
      <form onSubmit={submit} className="space-y-4">
        <div><Label className="text-xs">Full name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required data-testid="register-name" /></div>
        <div><Label className="text-xs">Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required data-testid="register-email" /></div>
        <div><Label className="text-xs">Mobile / WhatsApp (optional)</Label><Input value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} data-testid="register-mobile" /></div>
        <div><Label className="text-xs">Password</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="register-password" /></div>
        <label className="flex items-start gap-2 text-xs text-slate-500">
          <Checkbox checked={form.marketing_consent} onCheckedChange={(v) => setForm({ ...form, marketing_consent: !!v })} data-testid="register-consent" />
          I'd like to receive product updates and offers by email (optional).
        </label>
        {err && <p className="text-sm text-red-600" data-testid="register-error">{err}</p>}
        <Button type="submit" className="w-full bg-teal hover:bg-teal-dark text-white" disabled={loading} data-testid="register-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Create account"}
        </Button>
      </form>
      <div className="flex items-center gap-3 my-4"><div className="flex-1 h-px bg-slate-200" /><span className="text-xs text-slate-400">or</span><div className="flex-1 h-px bg-slate-200" /></div>
      <GoogleButton label="Sign up with Google" />
      <p className="text-sm text-slate-500 mt-6 text-center">Already have an account? <Link to="/login" className="text-teal font-medium" data-testid="to-login">Sign in</Link></p>
    </AuthShell>
  );
}
